import * as React from 'react';
import { connect } from 'react-redux';
import { ProgressBar, Button } from 'react-bootstrap';
import './SalesAddress.css';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';
import { setParkAddress } from '../../../actions/salesActions';
import { PERSONAL_INFO, VEHICLE_LOOKUP } from '../../../routes/routes';
import Geocode from "react-geocode";
import { navigateTo } from '../../../actions/navigationActions';
import { logErrorToDatabase } from '../../../actions/apiActions';
import { PRODUCT_BLING } from '../../../constants/constants';
import { NAM_COUNTRY_ID_NUMBER } from '../../../constants/internationalization';

var lat = null;
var lng = null;
const geoCodeApiKey = "AIzaSyA-H0lUISGUeL7ipjcqTTwK3gmMaSZynR8";

class SalesAddress extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            nextDisabled: true,
            lat: this.props.sales.addressLat,
            lng: this.props.sales.addressLon,
            openMap: false,
            addressSelect: this.props.sales.address, 
            loggedIn: this.props.auth.uid ? true : false,
            addressDetail: { province: null, suburb: null, city: null, postalCode: null, formatted: null }
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleaddressSelect = this.handleaddressSelect.bind(this);
        this.handleAdressChange = this.handleAdressChange.bind(this);
        this.updateLatLngAdress = this.updateLatLngAdress.bind(this);
        this.mapReady = this.mapReady.bind(this);
    }

    componentDidMount() {
        Geocode.setApiKey(geoCodeApiKey);
    }

    async updateLatLngAdress(Lat, Lng, address, addressDetail) {
        lat = Lat
        lng = Lng

        if (this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER) {
            addressDetail.province = addressDetail.province?.replace("REGION", "").trim();
            addressDetail.suburb = addressDetail.suburb ?? addressDetail.city;
        }

        await this.setState({ lat: Lat, lng: Lng, addressSelect: address, addressDetail });
    };

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
    }

    handleAdressChange = address => {
        this.setState({ addressSelect: address });
    };

    handleaddressSelect = address => {
        geocodeByAddress(address)
            .then(async (results) => {
                let latlong = await getLatLng(results[0]);
                let suburb, state, city, postal_code;
                const address = results[0];
                for (let i = 0; i < address.address_components.length; i++) {
                    for (let j = 0; j < address.address_components[i].types.length; j++) {
                        switch (address.address_components[i].types[j]) {
                            case "sublocality":
                                suburb = address.address_components[i].long_name.toUpperCase();
                                break;
                            case "administrative_area_level_1":
                                state = address.address_components[i].long_name.toUpperCase();
                                break;
                            case "locality":
                                city = address.address_components[i].long_name.toUpperCase();
                                break;
                            case "postal_code":
                                postal_code = address.address_components[i].long_name.toUpperCase();
                                break;
                        }
                    }
                }

                let addressDetails = { province: state, city: city, suburb: suburb, postalCode: postal_code, formatted: address.formatted_address };
                this.updateLatLngAdress(latlong.lat, latlong.lng, address.formatted_address, addressDetails);
            })
            .catch((err) => { logErrorToDatabase("Error retrieving geoCode by Address: " + address + ": " + err) });

        this.setState({ openMap: true, nextDisabled: false });
    };

    handleRedirect(nextPage: string) {
        this.props.redirectTo(nextPage);
    }

    handleClick() {
        this.props.dispatchAction(setParkAddress(this.state.lat, this.state.lng, this.state.addressSelect, this.state.addressDetail));
    }

    async handleBack(e: any) {
        if (this.props.sales.quoteType === PRODUCT_BLING) {
            this.props.redirectTo(PERSONAL_INFO)
        }
        else {
            this.props.redirectTo(VEHICLE_LOOKUP)
        }
    }

    async mapReady(mapProps, map) {
        lat = map.center.lat()
        lng = map.center.lng()
        await this.setState({ lat: lat, lng: lng });
        map.addListener("click", (mapsMouseEvent) => {
            lat = mapsMouseEvent.latLng.toJSON().lat
            lng = mapsMouseEvent.latLng.toJSON().lng

            Geocode.fromLatLng(lat, lng).then(
                (response) => {
                    let addressDetails = { province: "", suburb: "", city: "", postalCode: "", formatted: "" };
                    let suburb, state, city, postal_code;
                    const address = response.results[0];
                    for (let i = 0; i < address.address_components.length; i++) {
                        for (let j = 0; j < address.address_components[i].types.length; j++) {
                            switch (address.address_components[i].types[j]) {
                                case "sublocality":
                                    suburb = address.address_components[i].long_name.toUpperCase();
                                    break;
                                case "administrative_area_level_1":
                                    state = address.address_components[i].long_name.toUpperCase();
                                    break;
                                case "locality":
                                    city = address.address_components[i].long_name.toUpperCase();
                                    break;
                                case "postal_code":
                                    postal_code = address.address_components[i].long_name.toUpperCase();
                                    break;
                            }
                        }
                    }
                    addressDetails = { province: state, suburb: suburb, city: city, formatted: address.formatted_address, postalCode: postal_code };
                    this.updateLatLngAdress(lat, lng, address.formatted_address, addressDetails);
                },
                (error) => {
                    logErrorToDatabase("Error retrieving geoCode by Address: " + error);
                }
            );
            this.setState({ lat: lat, lng: lng });
        });
    }

    public render() {
        const countryFilter = this.props.profile.countryId === 244 ? "ZA" : "NA"
        return (
            <div className={this.state.loggedIn ? "pt-lg-5 p-lg-0 logged-in" : "pt-lg-5 p-lg-0 logged-out"}>
                <div className="col-12 mt-4 pb-4 text-lg-center text-md-center">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="row justify-content-center">
                                    <div className="col-2 col-md-3 col-lg-3 col-xl-2 pt-lg-2 text-center align-self-center">
                                        <div className="BackRectangle d-none d-lg-block d-md-block">
                                            <button onClick={this.handleBack} className="Back cursor-pointer"><img src="./images/OnlineQuotation/icon-back-button-desktop.png" alt="" /></button>
                                        </div>
                                        <div className="sidenav d-lg-none d-md-none" id="mySidenav">
                                            <button onClick={this.handleBack} className="Back cursor-pointer" id="about"><img src="./images/OnlineQuotation/icons-navigation-quote-back-btn.png" alt="" /></button>
                                        </div>
                                    </div>
                                    <div className="col-10 col-md-9 col-lg-9 col-xl-10 p-0 text-center align-self-center">
                                        <div>
                                            <ProgressBar variant="success" now={40} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12 pl-lg-0">
                                <div className="mt-5 text-center pl-lg-4">
                                    <img src="./images/OnlineQuotation/crown-icon.png" className="img-fluid" alt="" />
                                </div>
                                <div className="ma-top-21px text-center">
                                    <p className={"text-16 font-weight-500" + (this.props.sales.quoteType === PRODUCT_BLING ? " noma" : "") }>{this.props.sales.quoteType === PRODUCT_BLING ? "Home is where the heart is." : "Where will you park this car at night"}</p>
                                    {this.props.sales.quoteType === PRODUCT_BLING && <p className="text-16 font-weight-500">Where do you (the policyholder) stay</p> }
                                </div>
                                <div className="mb-5 form-row ma-top-20px">
                                    <div className="col-lg-12 col-12 p-0">
                                        {this.state.addressSelect !== "" &&
                                            <p className="text-left mb-1"><b>Physical address</b></p> ||
                                            <p style={{ visibility: "hidden" }} className="text-left mb-1"><b>Physical</b></p>}{/*keep tag to save space to not make screen jumpy*/}
                                        <div id="SalesAddress">
                                            <PlacesAutocomplete
                                                value={this.state.addressSelect}
                                                onChange={this.handleAdressChange}
                                                onSelect={this.handleaddressSelect}
                                                searchOptions={{ componentRestrictions: { country: countryFilter } }}
                                            >
                                                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                    <div className="position-relative">
                                                        <input
                                                            {...getInputProps({
                                                                placeholder: "Physical address",
                                                                className: " ssp-autocomplete-searchbox autocomplete-searchbox-bordered",
                                                            })}
                                                        />
                                                        <div className={(suggestions.length > 0 ? "ssp-autocomplete-dropdown-container" : "d-none")}>
                                                            {loading && <div className="ssp-autocomplete-loading">Loading...</div>}
                                                            {suggestions.map(suggestion => {
                                                                const className = "ssp-autocomplete-suggestion-item";
                                                                return (
                                                                    <>
                                                                        <div
                                                                            {...getSuggestionItemProps(suggestion, {
                                                                                className,
                                                                            })}
                                                                        >
                                                                            <span className="ssp-autocomplete-suggestion-actual">{suggestion.description}</span>
                                                                        </div>
                                                                        <div className="ssp-autocomplete-hr-container">
                                                                            <hr className="ssp-autocomplete-hr-divider" />
                                                                        </div>
                                                                    </>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                )}
                                            </PlacesAutocomplete>
                                            <div className={this.state.openMap ? "d-block" : "d-none"}>
                                                <Map google={this.props.google}
                                                    centerAroundCurrentLocation
                                                    center={{ lat: this.state.lat, lng: this.state.lng }}
                                                    onReady={this.mapReady}
                                                    containerStyle={{
                                                        position: 'relative',
                                                        overflow: 'hidden',
                                                        width: '100%',
                                                        height: '271px',
                                                    }}>
                                                    <Marker
                                                        // @ts-ignore
                                                        position={{ lat: this.state.lat, lng: this.state.lng }}
                                                        draggable={false}
                                                        title="Start typing"
                                                    />
                                                </Map>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row justify-content-center" style={{paddingBottom:"180px"}}>
                                    <div className="col-lg-3 col-md-3 col-xs-12 col-sm-12 personal-info-button-holder nopa">
                                        <Button className={"btn btn-block btn-solid-red" + (this.props.sales.quoteType === PRODUCT_BLING ? " button-width" : "")} id="submitButton" disabled={this.state.nextDisabled} onClick={this.handleClick}>Next</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (des) => dispatch(navigateTo(des)),
        dispatchAction: (e) => dispatch(e),
    }
}

const connector = connect(mapStateToProps, mapDispatchToProps)(SalesAddress);

export default GoogleApiWrapper({ apiKey: geoCodeApiKey })(connector);
